import {  Observable } from 'rxjs';
export class SharedURLsData {
    data: any;
    observable: Observable<any> = null;

}
